import * as React from 'react'
import PickingListQuantityInput from './PickingListQuantityInput'
import PickingListCopyQuantityButton from './PickingListCopyQuantityButton'
import AddPickingListLineButton from './AddPickingListLineButton'
import pickingListColorClass from './pickingListColorClass'
import pickingListExportTitle from './pickingListExportTitle'
import { PickingListRowShape, StagedPick } from '../../api/api_data_types'

interface PickingListRowProps {
  row: PickingListRowShape
  currentUser: { username: string }
  changedQuantities: Record<string, StagedPick>
  setChangedQuantities: React.Dispatch<React.SetStateAction<Record<string, StagedPick>>>
}

export default function PickingListRow({ row, currentUser, changedQuantities, setChangedQuantities }: PickingListRowProps) {
  const initialItem = row.item?.id != null ? { value: row.item.id, label: row.item.title } : undefined
  const addLineButton = (
    <AddPickingListLineButton
      jobId={row.job_id}
      currentUser={currentUser}
      initialItem={initialItem}
      buttonClass="btn btn-outline-primary btn-sm"
    />
  )

  if (row.row_type === 'record') {
    return (
      <tr
        className={`${row.nested ? 'picking-list-record-row' : ''} ${row.export_status !== 'exported' ? 'picking-list-export-pending' : ''}`}
        title={pickingListExportTitle(row)}
      >
        <td>{row.item && row.item.title}</td>
        <td className="align-middle">{row.item && row.item.shelf_no_east}</td>
        <td className="align-middle">{row.item && row.item.shelf_no_dgj}</td>
        <td className="align-middle">{row.location_code}</td>
        <td className="align-middle"></td>
        <td className="align-middle"></td>
        <td className="align-middle"></td>
        <td className="align-middle">{Number(row.quantity).toLocaleString('da-DK')}</td>
        <td className="align-middle">{!row.nested && addLineButton}</td>
      </tr>
    )
  }

  const estimatedQuantity = Number(row.estimated_quantity)
  const jobCostQuantity = Number(row.job_cost_quantity)

  return (
    <tr>
      <td>{row.item && row.item.title}</td>
      <td className="align-middle">{row.item && row.item.shelf_no_east}</td>
      <td className="align-middle">{row.item && row.item.shelf_no_dgj}</td>
      <td className="align-middle">{row.location_code}</td>
      <th className="align-middle">
        <PickingListQuantityInput row={row} changedQuantities={changedQuantities} setChangedQuantities={setChangedQuantities} />
      </th>
      <th className="align-middle">
        <PickingListCopyQuantityButton row={row} changedQuantities={changedQuantities} setChangedQuantities={setChangedQuantities} />
      </th>
      <td className="align-middle">{estimatedQuantity.toLocaleString('da-DK')}</td>
      <td className={`align-middle ${pickingListColorClass(row)}`}>{jobCostQuantity.toLocaleString('da-DK')}</td>
      <td className="align-middle">{addLineButton}</td>
    </tr>
  )
}
